import React, { Component } from 'react';
export class Footer extends Component {
  render() {
    return (
      <div className='container'>
        <div className='row pt-2'>
            <div className='col text-center pt-1'>
                <p className='text-silver'><a className='link-light text-grey text-muted' href='mailto:contact@kazcha50.info'>contact us</a></p>
            </div>
        </div>
      </div>
    );
  }
}
